import React, { useState, useEffect } from "react";
import "./users.css";
import { Breadcrumb, Table, Image } from "antd";
import { redTrash } from "../../assets";
import { callApi } from "../../api/apiCaller";
import { routes } from "../../api/routes";
import Loader from "../../components/loader/loader";
import SearchComp from "../../components/search/Search";
import DeleteModal from "../../components/deleteModal/DeleteModal";
import { useNavigate } from "react-router-dom";

const Users = () => {
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [updateApi, setUpdateApi] = useState(false);
  const [search, setSearch] = useState("");
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 5,
  });
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const navigate = useNavigate();

  const getAllUser = () => {
    let getRes = (res) => {
      console.log("res of user list", res);
      setUsers(res?.data?.data);
    };

    callApi("GET", routes.getAllUsers, null, setIsLoading, getRes, (error) => {
      console.log("error", error);
    });
  };

  const handleDeleteClick = (user) => {
    setSelectedUser(user);
    setDeleteModalVisible(true);
  };

  const handleDeleteConfirm = () => {
    if (selectedUser?._id) {
      deleteUser(selectedUser._id);
    }
  };

  const handleDeleteCancel = () => {
    setDeleteModalVisible(false);
    setSelectedUser(null);
  };

  const deleteUser = (id) => {
    setUpdateApi(false);
    let getRes = (res) => {
      console.log("res of user list", res);
      setUpdateApi(true);
      setDeleteModalVisible(false);
      setSelectedUser(null);
    };

    callApi(
      "DELETE",
      `${routes.deleteUser}/${id}`,
      null,
      setIsLoading,
      getRes,
      (error) => {
        console.log("error", error);
        setDeleteModalVisible(false);
        setSelectedUser(null);
      }
    );
  };

  useEffect(() => {
    getAllUser();
  }, [updateApi]);

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const parsed = new Date(dateString);
    if (Number.isNaN(parsed.getTime())) {
      return "N/A";
    }

    const datePart = new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }).format(parsed);

    const timePart = new Intl.DateTimeFormat("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }).format(parsed);

    return `${datePart} ${timePart}`;
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setPagination({
      ...pagination,
      current: pagination.current,
      pageSize: pagination.pageSize,
    });
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      className: "role-name-column-header",
      align: "center",
      sorter: (a, b) => (a.name || "").localeCompare(b.name || ""),
    },

    {
      title: "Email",
      dataIndex: "email",
      align: "center",
      className: "type-name-column-header",
      sorter: (a, b) => (a.email || "").localeCompare(b.email || ""),
    },
    {
      title: "Role",
      dataIndex: "role",
      align: "center",
      className: "action-column-header",
      render: (role) => {
        const normalized =
          typeof role === "string" ? role.toLowerCase().replace(/\s+/g, "-") : "default";
        return (
          <span className={`role-badge role-${normalized}`}>
            {role || "N/A"}
          </span>
        );
      },
    },
    {
      title: "User Created Date",
      dataIndex: "createdDate",
      align: "center",
      className: "action-column-header created-date-column",
      onHeaderCell: () => ({
        style: { minWidth: 240 },
      }),
      render: (text) => (
        <span className="created-date-cell">{text}</span>
      ),
      sorter: (a, b) =>
        new Date(a.createdDateRaw || 0).getTime() -
        new Date(b.createdDateRaw || 0).getTime(),
    },
    {
      title: "Profile Picture",
      dataIndex: "profilePicture",
      align: "center",
      className: "action-column-header profile-picture-column",
      onHeaderCell: () => ({
        style: { minWidth: 160 },
      }),
    },
    {
      title: "Number",
      dataIndex: "number",
      align: "center",
      className: "action-column-header",
    },
    // {
    //   title: "Subscription",
    //   dataIndex: "subscription",
    //   align: "center",
    //   className: "action-column-header",
    //   filters: [
    //     { text: "Not Subscribed", value: "not-subscribed" },
    //     { text: "Free", value: "free" },
    //     { text: "Premium", value: "premium" },
    //   ],
    //   onFilter: (value, record) => record.subscriptionPlan === value,
    // },
    {
      title: "Edit",
      dataIndex: "edit",
      align: "center",
      className: "action-column-header",
    },
    {
      title: "Delete",
      dataIndex: "delete",
      align: "center",
      className: "action-column-header",
    },
  ];

  const data = users
    ?.filter(
      (item) =>
        (item.name && item.name.toLowerCase().includes(search.toLowerCase())) ||
        (item.email && item.email.toLowerCase().includes(search.toLowerCase()))
    )
    ?.map((item, index) => {
      const normalizedRole =
        typeof item?.role === "string" ? item.role.toLowerCase() : "";
      const isAdmin = normalizedRole === "admin";

      return {
        key: index,
        name: item?.name,
        email: item?.email,
        role: item?.role || "N/A",
        createdDate: formatDate(item?.createdAt),
        createdDateRaw: item?.createdAt,
        number: item?.number,
        profilePicture: (
          <div className="product-list-image profile-picture-cell">
            <Image width={50} src={item?.image} alt="profile-image" />
          </div>
        ),
        subscription: (
          <p>
            {item?.subscriptionPlan === "premium"
              ? "Premium"
              : item?.subscriptionPlan === "free"
              ? "Free"
              : "Not Subscribed"}
          </p>
        ),
        subscriptionPlan:
          item?.subscriptionPlan === "premium"
            ? "premium"
            : item?.subscriptionPlan === "free"
            ? "free"
            : "not-subscribed",
        edit: (
          <div
            onClick={
              isAdmin ? undefined : () => navigate("/editUser", { state: { item } })
            }
            className={`action-icon-btn edit-btn${isAdmin ? " disabled" : ""}`}
            role="button"
            aria-disabled={isAdmin}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17 3C17.2626 2.73735 17.5744 2.52901 17.9176 2.38687C18.2608 2.24473 18.6286 2.17157 19 2.17157C19.3714 2.17157 19.7392 2.24473 20.0824 2.38687C20.4256 2.52901 20.7374 2.73735 21 3C21.2626 3.26264 21.471 3.57444 21.6131 3.9176C21.7553 4.26077 21.8284 4.62856 21.8284 5C21.8284 5.37143 21.7553 5.73923 21.6131 6.08239C21.471 6.42555 21.2626 6.73735 21 7L7.5 20.5L2 22L3.5 16.5L17 3Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span>Edit</span>
          </div>
        ),
        delete: (
          <div
            onClick={isAdmin ? undefined : () => handleDeleteClick(item)}
            className={`action-icon-btn delete-btn${isAdmin ? " disabled" : ""}`}
            role="button"
            aria-disabled={isAdmin}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 6H5H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M10 11V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M14 11V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <span>Delete</span>
          </div>
        ),
      };
    });

  const getRowClassName = (record, index) => {
    if (index % 2 === 0) {
      return "server-role-even-row";
    }
    return "server-role-odd-row";
  };

  return (
    <div className="modern-page-container">
      <Loader loading={isLoading} />
      <DeleteModal
        visible={deleteModalVisible}
        onConfirm={handleDeleteConfirm}
        onCancel={handleDeleteCancel}
        title="Delete User"
        message="Are you sure you want to delete user"
        itemName={selectedUser?.name}
        isLoading={isLoading}
      />

      {/* Page Header */}
      <div className="page-header">
        <div className="page-header-content">
          <div>
            <Breadcrumb
              separator="›"
              className="modern-breadcrumb"
              items={[
                { title: "Dashboard" },
                { title: <span className="breadcrumb-active">Users</span> },
              ]}
            />
            <h1 className="page-title">Users Management</h1>
            <p className="page-subtitle">Manage and view all registered users</p>
          </div>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="stats-container">
        <div className="stat-card">
          <div className="stat-icon" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M8.5 11C10.7091 11 12.5 9.20914 12.5 7C12.5 4.79086 10.7091 3 8.5 3C6.29086 3 4.5 4.79086 4.5 7C4.5 9.20914 6.29086 11 8.5 11Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M20 8V14M23 11H17" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <div className="stat-info">
            <p className="stat-label">Total Users</p>
            <h3 className="stat-value">{users?.length || 0}</h3>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon" style={{ background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)' }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 1.17157 16.1716C0.421427 16.9217 0 17.9391 0 19V21" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <div className="stat-info">
            <p className="stat-label">Premium Users</p>
            <h3 className="stat-value">{users?.filter(u => (u?.subscriptionPlan !== "not-subscribed" && u?.subscriptionPlan !== "free"))?.length || 0}</h3>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon" style={{ background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)' }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <div className="stat-info">
            <p className="stat-label">Free Users</p>
            <h3 className="stat-value">{users?.filter(u => (u?.subscriptionPlan === "not-subscribed" || u?.subscriptionPlan === "free"))?.length || 0}</h3>
          </div>
        </div>
      </div>

      {/* Search and Filters */}
      <div className="content-card">
        <div className="card-header">
          <h2 className="card-title">All Users</h2>
          <SearchComp
            placeHolder="Search by name or email..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        {/* Table */}
        <div className="table-container">
          <Table
            rowClassName={getRowClassName}
            columns={columns}
            dataSource={data}
            pagination={{
              ...pagination,
              showSizeChanger: true,
              showTotal: (total) => `Total ${total} users`,
            }}
            onChange={handleTableChange}
            scroll={{ x: 800 }}
          />
        </div>
      </div>
    </div>
  );
};

export default Users;
